import { View } from "@/components/ui";
import { getPlatform } from "@/lib/utils";

import { Typography } from "../typography";

export const TextSeparator = ({ label }: { label: string }) => {
  return (
    <View className="flex flex-1 flex-row items-center gap-1">
      <View className="divider bg-border h-[1px] flex-1" />

      <Typography
        // No fixed height on native: Android clips text to it, and at larger text
        // sizes cut the label in half. At 1× the line is the same 16pt
        className={getPlatform() === "web" ? "h-4" : undefined}
        variant="body-sm"
        color="foreground-intermediate"
      >
        {label}
      </Typography>

      <View className="divider bg-border h-[1px] flex-1" />
    </View>
  );
};
